import { Theme } from '@mui/material';
// import createTypography from '@mui/material/styles/createTypography';
import { TypographyVariantsOptions, TypographyVariants, private_createTypography } from '@mui/material/styles';

export const makeTypography = (theme: Theme): TypographyVariants => {
  const typography: TypographyVariantsOptions = {
    h1: {
      ...theme.typography.h1,
      color: theme.palette.darkSlate.main,
      fontWeight: 'bold',
      fontSize: '3.75rem',
      lineHeight: 1.2,
      letterSpacing: '-0.5px',
      [theme.breakpoints.down('md')]: {
        fontSize: '2.25rem',
      }
    },
    h2: {
      ...theme.typography.h2,
      color: theme.palette.darkSlate.main,
      fontWeight: 'bold',
      fontSize: '3rem',
      lineHeight: '116.7%',
      letterSpacing: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: '2.125rem'
      }
    },
    h3: {
      ...theme.typography.h3,
      color: theme.palette.darkSlate.main,
      fontWeight: 'bold',
      fontSize: '2.125rem',
      lineHeight: '123.5%',
      letterSpacing: '0.25px',
      [theme.breakpoints.down('md')]: {
        fontSize: '1.625rem'
      }
    },
    h4: {
      ...theme.typography.h4,
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '133.4%',
      [theme.breakpoints.up('sm')]: {
        fontWeight: 'normal',
        fontSize: '1.5rem',
        letterSpacing: 0,
      }
    },
    h5: {
      ...theme.typography.h5,
      fontWeight: 400,
      fontSize: '1.25rem',
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      [theme.breakpoints.down('md')]: {
        fontSize: '1.125rem'
      }
    },
    h6: {
      ...theme.typography.h6,
      fontWeight: 'bold',
      fontSize: '1.25rem',
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      [theme.breakpoints.down('md')]: {
        fontSize: '1.125rem'
      }
    },
    subtitle1: {
      ...theme.typography.subtitle1,
      fontSize: '1rem',
      lineHeight: 1.75,
      letterSpacing: '0.15px'
    },
    subtitle2: {
      ...theme.typography.subtitle2,
      fontWeight: 450,
      fontSize: '14px',
      lineHeight: '21.98px',
      letterSpacing: '0.1px',
      color: theme.palette.text.primary
    },
    body1: {
      ...theme.typography.body1,
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: '0.5px'
    },
    body2: {
      ...theme.typography.body2,
      color: 'rgba(0, 0, 0, .54)',
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.15px'
    },
    button: {
      ...theme.typography.button,
      fontFamily: "'FUTURA PT', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'uppercase',
      lineHeight: '1.5rem',
      letterSpacing: '1px'
    },
    caption: {
      ...theme.typography.caption,
      fontSize: '0.875rem',
      lineHeight: 1.66,
      letterSpacing: '0.4px'
    },
    overline: {
      ...theme.typography.overline,
      fontWeight: 'bold',
      fontSize: '0.75rem',
      textTransform: 'uppercase',
      lineHeight: 2.66,
      letterSpacing: '1px'
    },
  };

  return private_createTypography(theme.palette, {
    ...theme.typography,
    ...typography
  });
};
